import _ from 'lodash';
import moment from "moment";

export function isNullOrEmpty(value) {
  return value === undefined || value === null || _.isEmpty(value);
}

export function getObjectFromArray(array = []) {
  const output = {};
  array?.forEach(({ key, display }) => {
    output[key] = display;
  });
  return output;
}

/**
 * @param url
 * @param width
 * @returns string
 */
export function getImageUrl(url, width) {
  if (width) {
    return `${url}?width=${width}&auto=webp`;
  }
  return url;
}

/**
 *
 * @param { comparables: {}, featured }
 * @param { comparables: {}, featured }
 * @returns {number}
 */
export function sort(a, b, by) {
  if (!a || !b || !by) {
    return 0;
  }

  if (a.featured && !b.featured) {
    return -1;
  }

  if (!a.featured && b.featured) {
    return 1;
  }

  if (a.featured && b.featured) {
    return 0;
  }

  const aa = a.comparables
    && a.comparables.length
    && a.comparables.filter((c) => {
      if (by === 'PREMIUM') {
        // TODO This needs to be reworked but TI needs to be in prod tomorrow
        return c && c.title && (by === c.title.key || c.title.key === 'NOT_PREMIUM_TITLE');
      }
      return c && c.title && by === c.title.key;
    });

  const bb = b.comparables
    && b.comparables.length
    && b.comparables.filter((c) => {
      if (by === 'PREMIUM') {
        // TODO This needs to be reworked but TI needs to be in prod tomorrow
        return c && c.title && (by === c.title.key || c.title.key === 'NOT_PREMIUM_TITLE');
      }
      return c && c.title && by === c.title.key;
    });

  if (!aa || !bb || aa.length === 0 || bb.length === 0) {
    return 0;
  }

  let sortVal = 0;

  if (aa[0] && bb[0]) {
    const val = aa[0].sortValue - bb[0].sortValue;
    if (val !== 0) {
      sortVal = val;
    }
  }

  if (
    sortVal === 0
    && a.comparables
    && a.comparables.length
    && b.comparables
    && b.comparables.length
    && b.comparables.length === a.comparables.length
  ) {
    //  In this case I want to stop if the value != 0
    // which I can't see how can be done otherwise
    // eslint-disable-next-line
    for (var i = a.comparables.length - 1; i >= 0; i--) {
      const val = a.comparables[i].sortValue - b.comparables[i].sortValue;
      if (val !== 0) {
        return val;
      }
    }
  }

  return sortVal;
}

/**
 * TODO: Rewrite to be not shit
 * @param results
 * @param by
 * @returns {*}
 */
export function sortResults(results, by) {
  if (!by) {
    return results;
  }
  return results.sort((a, b) => sort(a, b, by));
}

export function calculateLoanAmount(propertyValue, borrowPercentage) {
  if (!_.isNumber(propertyValue) || !_.isNumber(borrowPercentage)) {
    return null;
  }
  return Math.round(propertyValue * (borrowPercentage / 100));
}

export function getListFilterFromFilterObject(filters) {
  return _.find(filters, { queryParam: 'list' }) || {};
}

export function getAllFiltersExcept(filters, queryParams = []) {
  return (filters || []).filter(({ queryParam }) => (
    queryParams.reduce((a, b) => a && queryParam !== b, true)
  ));
}

export function getFiltersDisplayByConfig(filters, filterControl = {}, list = null) {
  if (_.isEmpty(filterControl) || !list) return (filters || []);
  return (filters || []).filter(({ queryParam }) => {
    const show = filterControl?.[list]?.[queryParam]?.show;
    return (typeof show !== 'boolean') || show;
  });
}

export function getFilterWithQueryParam(filters, queryParam) {
  return _.find(filters, { queryParam }) || {};
}

export function getSortByValueFromSortByListIfNeeded(sortByValue, sortByList) {
  if (sortByValue) return sortByValue;
  return (_.last(sortByList) || {}).name;
}

export function getDefaultFilterValues(filterBy, defaultList) {
  return (filterBy || []).reduce((a, {
    queryParam,
    defaultValue,
    defaultSelection,
    selectStyle,
  }) => {
    let value = defaultValue;
    if (defaultSelection) {
      if (selectStyle === 'Single' && defaultSelection.length) {
        value = _.first(defaultSelection);
      } else {
        value = defaultSelection;
      }
    }
    return Object.assign(a, { [queryParam]: value });
  }, {
    list: defaultList,
  });
}

export function getProviderOptionsFromFilter(filter) {
  const { options = [] } = filter || {};
  return options
    .map(({ name, value }) => ({
      providerName: value,
      alias: name,
    }));
}

export function isUseCountdown(promotional) {
  return promotional?.countdown && promotional.countdown?.date?.endDate && moment(promotional.countdown?.date?.endDate).isValid();
}

export function isUseFlipBanner(promotional) {
  return promotional?.flipBanner
  && !_.isEmpty(promotional?.flipBanner?.imageForDesktop?.url);
}

export function isProductPaneUseFeature(promotional) {
  if (!promotional) return false;
  return isUseCountdown(promotional) || isUseFlipBanner(promotional);
}
